import React, { Component } from 'react';
/* Components */
import LoadingModal from '../common/loadingModal';
import EntityInput from '../common/forms/entityInput';
import DynamicListInput from '../common/forms/dynamicListInput';
import DateInput from '../common/extended_property/dateInput';
import utilFunction from '../../containers/function';

class ModalEdit extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div
        data-close="ok"
        onClick={this.props.handleClose}
        className={this.props.showModal ? `container-modal` : `container-modal hide`}
      >
        <section className="module-title modal-title">
          <h2>{"Editar solicitud"}</h2>
          {this.props.updateFlow.status == 500 &&
            this.props.updateFlow.data.error.params.map((item, i) => (
              <p key={i} className="error">
                {this.props.language.error[`cod${item.messageCode}`]}{' '}
              </p>
          ))}
          {this.props.updateFlow.status 
            && this.props.updateFlow.status !== 200 
            && this.props.updateFlow.status !== 500 && (  
            <p className="error">
              {this.props.language.error["apiErrorForm"]}{' '}
            </p>
          )}            
          {this.props.validateFlow.status == 500 &&
            this.props.validateFlow.data.error.params.map((item, i) => (
              <p key={i} className="error">
                {item.messageCode!="10013" ? this.props.language.error[`cod${item.messageCode}`] :
                this.props.language.error[`cod${item.messageCode}`] + item.linkBackId + "h."}{' '}
              </p>
          ))}
          {this.props.validateFlow.status 
            && this.props.validateFlow.status !== 200 
            && this.props.validateFlow.status !== 500 && (  
            <p className="error">
              {this.props.language.error["apiErrorForm"]}{' '}
            </p>
          )}
          <a>
            <i data-close="ok" onClick={this.props.handleClose} className="fas fa-times-circle" />
          </a>
        </section>
        {(this.props.updateFlow.status != 200 && this.props.selectedFlow) && (
          <div className={`box-modal max500`}>
            <section id="modal-edit" className="base-form">
              <div className="box-form islabel">
                <div>
                  <label className="modal-label">
                    {"Vehículo"}
                  </label>
                </div>
                <div>
                  <input type="hidden" defaultValue={this.props.selectedFlow.id} id="id" />
                  <EntityInput
                    id="vehicleIdUp"
                    dataUpdate="vehicleId"
                    value={this.props.selectedFlow.vehicleId ? this.props.selectedFlow.vehicleId : ""}
                    entities={this.props.vehicles}
                    className="modal-input"
                    onClickHandler={this.props.handleChange}
                    entityType="vehicle"
                    placeholder={"Desconocido"}
                  />
                </div>
              </div>
              <div className="box-form islabel">
                <div>
                  <label className="modal-label">
                    {"Tipo de Vehículo"}
                  </label>
                </div>
                <div>
                  <DynamicListInput
                    id="vehicleTypeUp"
                    dataUpdate="vehicleType"
                    value={this.props.selectedFlow.vehicleType ? this.props.selectedFlow.vehicleType : ""}
                    list={this.props.lists["VEHICLE TYPE"]}
                    className="modal-input"
                    onClickHandler={this.props.handleChange}
                    emptyValue={"Desconocido"}
                  />             
                </div>
              </div>
              {this.props.selectedFlow.vehicleType=="Sobredimensión" && (
                <div>
                  <div className="box-form islabel">
                    <div>
                      <label className="modal-label">
                        {"Número Permiso MOP"}
                      </label>
                    </div>
                    <div>
                      <input
                        data-update="mopPermit"
                        onChange={this.props.handleChange}
                        autoComplete="off"
                        value={this.props.selectedFlow.mopPermit ? this.props.selectedFlow.mopPermit : ""}
                        type="text"
                        id="mopPermitUp"
                        className="modal-input"
                      />
                    </div>
                  </div>
                  <div className="box-form islabel">
                    <div>
                      <label className="modal-label">
                        {"Archivo Permiso MOP"}
                      </label>
                    </div>
                    <div>
                      <input
                        data-update="mopPermitFiles"
                        onChange={this.props.handleChange}
                        type="file"
                        id="mopPermitFilesUp"
                        name="mopPermitFilesUp"
                        className="modal-input"
                        accept={'.doc, .docx, application/pdf, image/*'}
                        multiple
                      />
                    </div>
                  </div>
                  <div className="box-form islabel">
                    <div>
                      <label className="modal-label">
                        {"Escolta"}
                      </label>
                    </div>
                    <div>
                      <DynamicListInput
                        id="escortUp"
                        dataUpdate="escort"
                        value={this.props.selectedFlow.escort ? this.props.selectedFlow.escort : ""}
                        list={this.props.lists["ESCORT"]}
                        className="modal-input"
                        onClickHandler={this.props.handleChange}
                        emptyValue={"Desconocido"}
                      />  
                    </div>
                  </div>
                </div>
              )}
              <div className="box-form islabel semi-trailer-input">
                <div>
                  <label className="modal-label">
                    {"Rampla"}
                  </label>
                  <label className="modal-label">
                    {"Tipo"}
                  </label>
                </div>
                <div>
                  <EntityInput
                    id="semiTrailerIdUp"
                    dataUpdate="semiTrailerId"
                    value={this.props.selectedFlow.semiTrailerId ? this.props.selectedFlow.semiTrailerId : ""}
                    entities={this.props.semiTrailers}
                    className="modal-input"
                    onClickHandler={this.props.handleChange}
                    entityType="semiTrailer"
                    placeholder={"Desconocido"}
                  />
                  <div className="semi-trailer-type">
                    {this.props.getSemiTrailerType(this.props.selectedFlow.semiTrailerId)}
                  </div>
                </div>
              </div>
              <div className="box-form islabel">
                <div>
                  <label className="modal-label">
                    {"Conductor"}
                  </label>
                </div>
                <div>
                  <EntityInput
                    id="personIdUp"
                    dataUpdate="personId"
                    value={this.props.selectedFlow.personId ? this.props.selectedFlow.personId : ""}
                    entities={this.props.drivers}
                    className="modal-input"
                    onClickHandler={this.props.handleChange}
                    entityType="person"
                    placeholder={"Desconocido"}
                  />
                </div>
              </div>
              <div className="box-form islabel">
                <div>
                  <label className="modal-label">
                    {"Gerencia"}
                  </label>
                </div>
                <div>
                  <DynamicListInput
                    id="managementUp"
                    dataUpdate="management"
                    value={this.props.selectedFlow.management ? this.props.selectedFlow.management : ""}
                    list={this.props.lists["MANAGEMENT"]}
                    className="modal-input"
                    onClickHandler={this.props.handleChange}
                    emptyValue={"Desconocido"}
                  />   
                </div>
              </div>
              <div className="box-form islabel">
                <div>
                  <label className="modal-label">
                    {"Carga"}
                  </label>
                </div>
                <div>
                  <input
                    data-update="load"
                    onChange={this.props.handleChange}
                    autoComplete="off"
                    value={this.props.selectedFlow.load ? this.props.selectedFlow.load : ""}
                    type="text"
                    id="loadUp"
                    className="modal-input"
                  />
                </div>
              </div>
              <div className="box-form islabel">
                <div>
                  <label className="modal-label">
                    {"Dirección"}
                  </label>
                </div>
                <div>
                  <DynamicListInput
                    id="directionUp"
                    dataUpdate="direction"
                    value={this.props.selectedFlow.direction ? this.props.selectedFlow.direction : ""}
                    list={this.props.lists["DIRECTION"]}
                    className="modal-input"
                    onClickHandler={this.props.handleChange}
                    emptyValue={"Desconocido"}
                  /> 
                </div>
              </div>
              <div className="box-form islabel">
                <div>
                  <label className="modal-label">
                    {"Fecha"}
                  </label>
                </div>
                <div>
                  <DateInput
                    date={this.props.selectedFlow.date ? this.props.selectedFlow.date : ""}
                    id="dateUp"
                    dataUpdate="date"
                    className="modal-input"
                    onClickHandler={this.props.handleChange}
                    disableYearSelection={true}
                  />
                </div>
              </div>
              <div className="box-form islabel">
                <div>
                  <label className="modal-label">
                    {"Hora"}
                  </label>
                </div>
                <div>
                  <DynamicListInput
                    id="timeUp"
                    dataUpdate="time"
                    value={this.props.selectedFlow.time ? this.props.selectedFlow.time : ""}
                    list={utilFunction.getTimeIntervalsArray(10,this.props.selectedFlow.vehicleType,this.props.selectedFlow.time)}
                    className="modal-input"
                    onClickHandler={this.props.handleChange}
                    emptyValue={"Desconocido"}
                  /> 
                </div>
              </div>
              <div className="box-form islabel">
                <div>
                  <label className="modal-label">
                    {"Email"}
                  </label>
                </div>
                <div>
                  <input
                    data-update="email"
                    onChange={this.props.handleChange}
                    autoComplete="off"
                    value={this.props.selectedFlow.email ? this.props.selectedFlow.email : ""}
                    type="text"
                    id="emailUp"
                    className="modal-input"
                  />
                </div>
              </div>
              <div className="box-form islabel">
                <div>
                  <label className="modal-label">
                    {"Commentario"}
                  </label>
                </div>
                <div>
                  <textarea
                    data-update="comments"
                    onChange={this.props.handleChange}
                    autoComplete="off"
                    value={this.props.selectedFlow.comments ? this.props.selectedFlow.comments : ""}
                    id="commentsUp"
                    className="modal-input"
                  />
                </div>
              </div>
            </section>
          </div>
        )}
        {this.props.updateFlow.status != 200 && (
          <div className={'box-form islabel top center modal-button-box '}>
            <div>
              {this.props.updateFlow.loading || this.props.validateFlow.loading ? (
                <div className="spiner">
                  <i className="fas fa-spinner fa-spin" /> Cargando
                </div>
              ) : (
                <input
                  className="active"
                  onClick={this.props.handleSubmit}
                  type="button"
                  value={"Editar solicitud"}
                />
              )}
            </div>
          </div>
        )}
        {this.props.updateFlow.status == 200 && (
          <div className={`box-modal max500`}>
            <section
              className={'feed-back green'}
            >
              <div>
                <i className="fas fa-check-circle" />
              </div>
              <div>
                <p>
                  {"Salvado con exito"}
                </p>
              </div>
            </section>
          </div>
        )}
      </div>
    );
  }
}

export default ModalEdit;



// WEBPACK FOOTER //
// ./source/client/components/flow_applicant_detail/modalEdit.jsx